<template>
  <v-menu
    key="shared-user-menu-child-component"
    :close-on-content-click="false"
    v-model="userMenuOpen"
    :model-value="userMenuOpen"
    persistent
  >
    <template v-slot:activator="{ props: menuActivatorProps }">
      <v-btn class="ml-2" variant="text" v-bind="menuActivatorProps" :loading="updatingWorkspace">
        <v-icon start> mdi-plus-circle-outline </v-icon>
        {{ $t('workspaces.text.addUser') }}
      </v-btn>
    </template>
    <v-card width="14rem">
      <v-text-field
        v-model="search"
        :placeholder="$t('basicActions.search')"
        hide-details
        density="compact"
        autofocus
      >
        <template #prepend-inner>
          <v-icon> mdi-account-search </v-icon>
        </template>
      </v-text-field>
      <v-list :class="loadingUsers ? 'text-center' : undefined" max-height="20rem">
        <template v-if="loadingUsers">
          <v-progress-circular indeterminate width="1" size="25" />
        </template>
        <template v-else>
          <v-list-item
            v-for="(user, index) in sortedAndFilteredUsers"
            :key="user.uid"
            @click="$emit('add-workspace-user', user.uid)"
          >
            <template #prepend>
              <v-avatar variant="outlined" size="23">
                {{ user.display_name[0] }}
              </v-avatar>
            </template>
            <v-list-item-title>
              {{ user.display_name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ user.email }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item v-if="sortedAndFilteredUsers.length === 0">
            <v-list-item-subtitle>
              {{ $t('workspaces.text.noUsersFound') }}
            </v-list-item-subtitle>
          </v-list-item>
        </template>
      </v-list>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="userMenuOpen = false">
          {{ $t('basicActions.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { useFirestoreUsers } from '@/composables/users/useFirestoreUsers'
import { useAuthStore } from '@/store/auth'
import { mapStores } from 'pinia'
import { log } from '@/plugins/logger'

export default {
  name: 'UserList',
  props: {
    workspace: {
      type: Object,
      required: true
    },
    updatingWorkspace: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const { users, loadingUsers, getAllTenantUsers } = useFirestoreUsers()
    return {
      users,
      loadingUsers,
      getAllTenantUsers
    }
  },
  data() {
    return {
      search: '',
      userMenuOpen: false
    }
  },
  computed: {
    ...mapStores(useAuthStore),

    sortedAndFilteredUsers() {
      const lowerCaseSearch = this.search.toLowerCase()

      return Object.values(this.users)
        .filter(user => {
          const matched = user.display_name.toLowerCase().includes(lowerCaseSearch)
          const alreadyShared = this.workspace.shared_users.includes(user.uid)
          const notSelf = user.uid !== this.authStore.userData.uid
          const notWorkspaceOwner = user.uid !== this.workspace.created_by
          const isSyftAdminAccount = user.email.includes('syft@') || user.email.includes('admin@')
          return matched && !alreadyShared && notSelf && notWorkspaceOwner && !isSyftAdminAccount
        })
        .sort((a, b) => a.display_name.localeCompare(b.display_name))
    }
  },
  async mounted() {
    await this.getAllTenantUsers()
  }
}
</script>
